<script>
    import { onMount } from 'svelte';

    let el = null;
    export let width = '0';
    export let height = '0';
    let visible = false;
    let hasBeenIsVisible = false;

    onMount(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                visible = entries[0].isIntersecting;
                hasBeenIsVisible = hasBeenIsVisible || visible;
            },
            { rootMargin: '200px 200px 200px 200px' }
        );
        observer.observe(el);

        return () => observer.unobserve(el);
    });

    $: style = !hasBeenIsVisible ? `min-height: ${height || 0}; min-width: ${width || 0}` : null;
</script>

<div bind:this={el} {style}>
    <slot {visible} {hasBeenIsVisible} />
</div>
